interface AdSlotProps {
  variant: 'sidebar' | 'banner';
  label?: string;
}

/*
 * Intentional Google AdSense placeholder.
 * To activate: add your AdSense script to index.html, then replace the inner
 * <div> with your <ins class="adsbygoogle" ...> unit. The reserved min-height
 * stops layout shift (CLS) when the ad loads.
 */
function AdSlot({ variant, label = 'Advertisement' }: AdSlotProps) {
  const size = variant === 'sidebar' ? 'min-h-[250px] lg:min-h-[600px]' : 'min-h-[110px] sm:min-h-[120px]';
  return (
    <aside aria-label={label} className="my-8">
      


      





    </aside>);

}

export default AdSlot;